import React from 'react';
import { useInView } from 'react-intersection-observer';
import { Quote, Star, ArrowRight } from 'lucide-react';

const SocialProof: React.FC = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const testimonials = [
    {
      industry: '建設業',
      company: '広島県・従業員12名',
      quote: 'Excelで管理していた工事台帳をシステム化。集計作業が半日から5分になり、月末の残業がほぼゼロになりました。',
      result: '月末集計 半日→5分',
      stars: 5,
    },
    {
      industry: '飲食業',
      company: '広島県・3店舗展開',
      quote: '他社に300万と言われたシフト管理システムを、80万円で実現してもらいました。スマホからも確認できて、スタッフにも好評です。',
      result: '開発費用 300万→80万円',
      stars: 5,
    },
    {
      industry: '士業事務所',
      company: '広島県・司法書士事務所',
      quote: 'ITに詳しくない私にも分かる言葉で説明してくれました。開発者と直接やり取りできるので、イメージ通りのものが出来上がりました。',
      result: '開発期間 わずか3週間',
      stars: 5,
    },
  ];

  return (
    <section className="py-20 lg:py-28 bg-[#F5F3EF]">
      <div className="mx-auto max-w-6xl px-5 lg:px-6">
        <div
          ref={ref}
          className={`transition-all duration-1000 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="text-center mb-14">
            <div className="inline-flex items-center gap-2 rounded-full border border-[#B8860B]/30 bg-[#B8860B]/10 px-4 py-1.5 mb-6">
              <span className="text-sm font-semibold text-[#B8860B]">お客様の声</span>
            </div>
            <h2 className="text-3xl font-bold lg:text-4xl leading-tight text-[#2D3748]">
              導入企業の<br />
              <span className="text-gradient">リアルな声</span>
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mb-10">
            {testimonials.map((item, index) => (
              <div
                key={index}
                className="rounded-2xl border border-[#E8E6E1] bg-white p-6 lg:p-8 shadow-sm transition-all duration-300 hover:shadow-md hover:-translate-y-1 flex flex-col"
              >
                {/* 業種タグ */}
                <div className="flex items-center gap-2 mb-4">
                  <span className="inline-flex items-center rounded-full bg-[#1B2A4A]/10 px-3 py-1 text-xs font-bold text-[#1B2A4A]">
                    {item.industry}
                  </span>
                  <span className="text-xs text-[#7B8794]">{item.company}</span>
                </div>

                {/* 星評価 */}
                <div className="flex gap-0.5 mb-4">
                  {Array.from({ length: item.stars }).map((_, i) => (
                    <Star key={i} className="h-4 w-4 fill-[#B8860B] text-[#B8860B]" />
                  ))}
                </div>

                {/* 引用 */}
                <div className="flex-1 mb-5">
                  <Quote className="h-5 w-5 text-[#B8860B]/30 mb-2" />
                  <p className="text-[#5A6577] leading-relaxed text-justify">
                    {item.quote}
                  </p>
                </div>

                {/* 成果 */}
                <div className="rounded-xl bg-[#1B2A4A] px-4 py-3 text-center">
                  <span className="text-sm font-bold text-[#B8860B]">{item.result}</span>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="text-center">
            <a
              href="#contact"
              className="group inline-flex items-center justify-center gap-2 rounded-lg bg-[#B8860B] px-7 py-3.5 text-white font-semibold hover:bg-[#A0750A] transition-colors shadow-lg shadow-[#B8860B]/30"
            >
              無料で相談する
              <ArrowRight className="h-4 w-4 transform group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
